// CRS 订单
import http from './http';

// 根据渠道单号查明文手机号
export const getMobileByOrderNo = (data) => {
  return http({
    method: 'POST',
    url: `/desensitization/common`,
    data,
  });
};

// 订单详情
export const getOrderDetail = (orderNo: string) => {
  return http({
    method: 'GET',
    url: `/crs/order/${orderNo}`,
  });
};

// 拒绝接单
export const refuseOrder = (data) => {
  return http({
    method: 'POST',
    url: '/crs/order/refuse-order',
    data,
  });
};

// 同意取消订单
export const setCancelToAgree = (data) => {
  return http({
    method: 'POST',
    url: '/crs/order/agree-cancel',
    data,
  });
};

// 拒绝取消订单
export const setCancelToRefuse = (data) => {
  return http({
    method: 'POST',
    url: '/crs/order/refuse-cancel',
    data,
  });
};

// 预订下单
export const createReserve = (data) => {
  return http({
    method: 'POST',
    url: '/reservation/crs-create',
    data,
  });
};

// 根据crs
export const getInfoByCRSOrder = (channelOrderNo: string) => {
  return http({
    method: 'POST',
    url: '/sub/order/list/by/condition',
    data: { channelOrderNo },
  });
};
